import script from "./RedeemPoints2.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemPoints2.vue?vue&type=script&setup=true&lang=js"

import "./RedeemPoints2.vue?vue&type=style&index=0&id=f91e1fc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f91e1fc2"]])

export default __exports__